import React from "react";
import { Link } from "react-router-dom";
import "./physics-overview.scss";
import Image4 from "../../assets/images/lecturers.JPG";

export const PhysicsOverview = () => {
  return (
    <>
      {" "}
      <div className="phy-overview-page">
        <center>
          <h1>Studying Physics - Overview</h1>
        </center>
        <div className="flexy flexyM offset-md-5 mt5">
          {" "}
          <Link to={"/"} className="home-link">
            HOME
          </Link>
          <span>
            <i class="icofont-rounded-right"></i>
          </span>
          <h6>Studying physics</h6>
        </div>
      </div>
      <center>
        <div className="col-md-6 mt">
          <p>
            <strong>
              Training future generations of physical scientists is a central
              pillar of the Cavendish’s programme. The Laboratory attracts large
              numbers of the brightest young scientists from the UK and overseas
              at both undergraduate and postgraduate levels. Ability at problem
              solving and finding original and imaginative solutions in
              experimental and theoretical physics are key skills which are
              fostered at all stages in their training.
            </strong>
          </p>
        </div>
      </center>
      <div className="col-md-8 offset-md-2 mt">
        <h5>Undergraduate Teaching</h5>
        <p>
          The main undergraduate course has a three- or four-year structure with
          over 80% of the students opting to complete the fourth year and to
          obtain an MSci. Our objective is to teach and train undergraduates in
          the complete spectrum of experimental and theoretical physics at the
          highest level and to ensure that they are exposed to the many ways in
          which physics can bring new insights and advances in cognate fields of
          research.
        </p>
        <p>
          Physics at undergraduate level is offered through the Natural Sciences
          Tripos (NST) in conjunction with other physical and biological
          sciences, and allows specialisation to occur as the students progress
          through the Tripos.
        </p>
        <p>
          The undergraduate course is highly regarded and exceptionally
          comprehensive, ranging from theoretical research to new
          interdisciplinary subjects such as the physics of the life sciences.
          Physics students are able to develop their enthusiasm and ingenuity
          through the challenges provided by the course. In the later years of
          the course, students can gain examination credit in non-traditional
          physics areas such as entrepreneurship and education. Each year,
          typically, over 100 students graduate from the four-year course.
        </p>
        <Link to={"/undergraduates"}>Prospective Undergraduates</Link>
        <br />
        <Link to={"/current-undergraduates"}>Current Undergraduates</Link>
        <div className="flexy mt7">
          <div className="col-md-6">
            <h5>Postgraduate Teaching & Training</h5>
            <p>
              The Laboratory offers postgraduate students from all over the
              world the opportunity to study with world-class researchers
              across, effectively, the complete spectrum of physics, from
              studies of the very early universe, over quantum and
              condensed-matter physics, to the physics of medicine.
            </p>
            <p>
              There are taught programmes on Data Intensive Science, Scientific
              Computing and Nanotechnology as well as as research-based courses,
              where students interact closely with the academic staff members
              and a large group of post-doctoral workers and research fellows in
              an intellectually stimulating environment. About 70-80
              postgraduate students join the Laboratory each year, resulting in
              a cohort of about 400 students within the Laboratory at any one
              time. The courses lead to a PhD after 3-4 years or an MPhil after
              one year.{" "}
            </p>
            <p>
              The Master of Advanced Study (MASt) degree in Physics allows
              students from outside Cambridge to study the fourth year of the
              undergraduate degree course for a standalone Masters.
            </p>
            <Link to={"/post-undergraduate"}>More information</Link>
          </div>
          <div className="col-md-6">
            <img className="" src={Image4} alt="Scholar" width="100%" />
          </div>
        </div>
        <br />
        <h5>STATEMENT OF ACADEMIC POLICIES</h5>
        <p>
          This statement of Academic policies was issued first in 1977. It was
          revised in 1983 to reflect the reorganization from School to a
          Faculty-Department system and in 1990 to reflect changes in line with
          the NUC Minimum Aca­demic Standards. This revision reflects changes
          made by Senate in 1995 and finally revised in 2002.
        </p>{" "}
        <h5>ACADEMIC OBJECTIVES</h5>
        <p>
          The Academic Objectives of the department is rooted in that of the
          Univer­sity of Port Harcourt as a whole:
        </p>
        <p>
          <em>
            ‘’TO CONTRIBUTE TO NATIONAL DEVLEOPMENT, SELF-RELIANCE AND UNITY
            THROUGH THE ADVANCEMENT AND PROPAGATION OF KNOWLEDGE AND TO USE SUCH
            KNOWLEDGE FOR SERVICE TO THE COMMUNITY AND TO HUMANITY’’
          </em>
        </p>
        <p>To this end:</p>
        <ol>
          <li>
            Degree programmes shall be provided with the objective of produc­ing
            persons who are well grounded in contemporary cul­ture, have sound
            knowledge of at least one branch of learning, and are intellectually
            and morally well equipped to make an effec­tive contribution to
            national development, self-reliance and unity.
          </li>
          <li>
            Research Facilities shall be provided for staff and students to
            un­dertake research relevant to the total development of Nigeria.
          </li>
          <li>
            Continuing education programmes shall be provided for the bene­fit
            of persons in the various sectors of the economy and in the public
            service, with a view to increasing their efficiency and productivity
            through knowledge of new developments relating to their work.
          </li>
          <li>
            Programmes shall be provided to assist the local community to
            benefit from the facilities provided by the institution.
          </li>
        </ol>
        <p>The General framework for the degree structure is as follows:</p>
      </div>
    </>
  );
};
